export default __webpack_public_path__ + "static/media/e6.964c9bd7.jpg";